// tints of the CADINU semantic colours (text inside uses the theme colour, never a hard-coded hex)
const variants = {
  warning: {
    background: "rgba(255, 179, 92, 0.12)",
    borderColor: "warning",
  },
  danger: {
    background: "rgba(255, 107, 122, 0.12)",
    borderColor: "failure",
  },
  success: {
    background: "rgba(57, 217, 138, 0.10)",
    borderColor: "success",
  },
  primary: {
    background: "rgba(127, 212, 232, 0.10)",
    borderColor: "primary",
  },
};

export default variants;
